import { render } from "./ItemToolbar.vue?vue&type=template&id=2bad1842&scoped=true&ts=true"
import script from "./ItemToolbar.vue?vue&type=script&lang=ts"
export * from "./ItemToolbar.vue?vue&type=script&lang=ts"

import "./ItemToolbar.vue?vue&type=style&index=0&id=2bad1842&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bad1842"]])

export default __exports__